import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { INTERACTIONS, SCENARIOS } from '../constants/Constants';
import { CompositeSpine } from 'game/components/CompositeSpine.js';
import { Xylophone } from 'game/interactions/humalong/display/Xylophone.js';
export default class SpinePreview extends SceneBase {
  constructor() {
    super({ key: KEYS.SpinePreview, active: false });
  }

  preload() {
    this.centerX = 910;
    this.centerY = 390;
    this.load.crossOrigin = 'anonymous';
    this.load.setPath(this.game.appUrls.resolveRelativeUrl('/assets/'));
    this.load.json('spineconfig', 'spinepreview.json');

    // load spinner
    this.spinner = this.add.graphics();
    for (let i = 0; i < 360; i += 40) {
      const tx = 50 * Math.sin(i * (Math.PI / 180));
      const ty = 50 * Math.cos(i * (Math.PI / 180));
      this.spinner.fillStyle(0xffffff, 1 - i / 360);
      this.spinner.fillCircle(tx, ty, 10);
    }
    this.spinner.x = this.centerX;
    this.spinner.y = this.centerY;
    this.tweens.add({
      targets: this.spinner,
      angle: 360,
      repeat: -1,
      duration: 1000,
    });
  }

  create() {
    super.create();

    this.config = this.cache.json.get('spineconfig');
    this.characters = this.config.characters;
    this.spines = this.config.spines;
    this.setBackgroundColour(this.config.background);
    this.spinner.visible = false;

    this.domContainer = document.createElement('div');
    this.domContainer.className = 'spine_options';
    this.domContainer.style.position = 'absolute';
    this.domContainer.style.top = '10px';
    this.domContainer.style.right = '10px';
    document.body.appendChild(this.domContainer);
    this.renderSpineOptions();
  }

  getSpineData() {
    return this.spines[this.activeCharacter];
  }

  getSpineKey() {
    return this.getSpineData().spine_key;
  }

  getAnimData(ind) {
    return this.getSpineData().animations[ind];
  }

  getAnimName(name) {
    return name;
  }

  renderSpineOptions() {
    if (!this.spineoptions) {
      const title = document.createElement('p');
      title.innerHTML = 'select character';
      this.domContainer.appendChild(title);
      //
      this.spineoptions = document.createElement('select');
      document.body.appendChild(this.spineoptions);

      this.spineoptions.addEventListener('change', (e) => {
        this.handleCharacterSelect(this.characters[this.spineoptions.value]);
      });

      this.domContainer.appendChild(this.spineoptions);
    } else {
      this.spineoptions.innerHTML = '';
    }

    // add character to list
    this.characters.forEach((entry, index) => {
      const option = document.createElement('option');
      option.innerHTML = entry;
      option.value = index;
      this.spineoptions.appendChild(option);
    });

    // select first character
    this.handleCharacterSelect(this.characters[0]);
  }

  handleCharacterSelect(character) {
    if (this.spineAnim) {
      this.spineAnim.destroy();
    }
    //
    this.activeCharacter = character;

    // load new spine
    const anim = this.spines[this.activeCharacter];
    let key = false;
    let keys = false;
    if (Array.isArray(anim.spine_key)) {
      keys = anim.spine_key;
    } else {
      key = anim.spine_key;
    }
    const name = anim.spine_name;

    // disable drop downs
    this.spineoptions.setAttribute('disabled', true);
    this.animationOptions?.setAttribute('disabled', true);

    this.load.setPath(this.game.appUrls.resolveRelativeUrl('assets/' + anim.spine_path));
    if (key) {
      this.load.spine(key, name + '.json', name + '.atlas');
      this.load.once('complete', this.handleSpineLoaded, this);
      this.load.start();
    } else if (keys) {
      for (const key of keys) {
        this.load.spine(key, key + '.json', key + '.atlas');
      }
      this.load.once('complete', this.handleSpineLoaded, this);
      this.load.start();
    }

    // show loader
    this.spinner.visible = true;
  }

  handleSpineLoaded() {
    // hide loader
    this.spinner.visible = false;

    // enable spine dropdown
    this.spineoptions.removeAttribute('disabled');
    this.animationOptions?.removeAttribute('disabled');

    //
    const data = this.getSpineData();
    const isMultiSpine = Array.isArray(data.spine_key);
    // add spine
    if (!isMultiSpine) {
      this.spineAnim = this.add.spine(
        this.centerX,
        this.centerY + data.offset_y,
        this.getSpineKey()
      );
      this.spineAnim.scale = data.scale;
    } else {
      const opts = {
        scene: this,
        position: { x: this.centerX, y: this.centerY + data.offset_y },
        scale: data.scale,
        keys: data.spine_key,
      };
      if (this.activeCharacter === 'xylophone') {
        this.spineAnim = new Xylophone(opts);
      } else {
        this.spineAnim = new CompositeSpine(opts);
      }
    }

    // set background
    this.cameras.main.setBackgroundColor(data.background || this.config.background);

    //
    this.renderAnimationOptions(this.activeCharacter);
  }

  renderAnimationOptions(character) {
    if (!this.animationOptions) {
      const title = document.createElement('p');
      title.innerHTML = 'select animation';
      this.domContainer.appendChild(title);
      //
      this.animationOptions = document.createElement('select');
      this.animationOptions.addEventListener('change', (e) => {
        this.handleAnimationSelect(this.getAnimData(this.animationOptions.value).spine_name);
      });
      this.domContainer.appendChild(this.animationOptions);
    } else {
      this.animationOptions.innerHTML = '';
    }

    // add anims to list
    const animations = this.getSpineData().animations;
    animations.forEach((anim, index) => {
      const option = document.createElement('option');
      option.innerHTML = anim.display_name;
      option.value = index;
      this.animationOptions.appendChild(option);
    });

    // select 1st animation
    this.handleAnimationSelect(this.getAnimData(0).spine_name);
  }

  handleAnimationSelect(animation) {
    const chain = animation.split(',');
    console.log('handleAnimationSelect', chain);
    this.spineAnim && this.spineAnim.removeAllListeners('complete');
    if (chain.length > 1) {
      this.chainAnimation = true;
      this.spineAnim.chainIndex = 0;
      this.spineAnim.on('complete', () => {
        this.spineAnim.chainIndex++;
        this.spineAnim.play(this.getAnimName(chain[this.spineAnim.chainIndex % chain.length]));
      });
      this.spineAnim.play(this.getAnimName(chain[this.spineAnim.chainIndex % chain.length]));
    } else {
      animation = this.getAnimName(animation);
      this.spineAnim.play(animation, true, false);
    }
  }
}
